<h1 mat-dialog-title>{{'DROPDOWN.PROF.PROFILE' |  anessaTranslation: trigger}}</h1>
<ul>
  <li>
    <h4>{{'DROPDOWN.PROF.NAME' |  anessaTranslation: trigger}}: {{data.account_name}}</h4>
  </li>
  <li>
    <h4>{{'DROPDOWN.PROF.EXP' |  anessaTranslation: trigger}}: {{data.anessa_license?.expiration_date | date : "dd/MM/y"}}</h4>
  </li>
  <li>
    <h4>{{'DROPDOWN.PROF.MAX_PROJ' |  anessaTranslation: trigger}}: {{data.anessa_license?.max_projects}}</h4>
  </li>
  <li>
    <h4>{{'DROPDOWN.PROF.MAX_USER' |  anessaTranslation: trigger}}: {{data.anessa_license?.max_users}}</h4>
  </li>
  <li>
    <h4>{{'DROPDOWN.PROF.USERS' |  anessaTranslation: trigger}}:</h4>
    <ul>
      <li *ngFor="let user of data.users">
        {{user.name}} - {{user.email}}
      </li>
    </ul>
  </li>
  <li>
    <h4>{{'DROPDOWN.PROF.ADMINS' |  anessaTranslation: trigger}}:</h4>
    <ul>
      <ng-container *ngFor="let user of data.users">
        <ng-container *ngIf="user.accountadmin">
          <li>
            {{user.name}} - {{user.email}}
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </li>
  <li>
    <h4>{{'DROPDOWN.PROF.TOKENS' |  anessaTranslation: trigger}}:</h4>
    <ul>
      <li *ngFor="let token of data.tokens">
        {{token}}
      </li>
    </ul>
  </li>
</ul>








